'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { Image } from '@/components/client';

import { TYPOGRAPHY_IMAGES } from '../../constants';
import { RegionListContent } from './List';

const containerVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const HowToCollect = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      className="flex w-full flex-col items-center bg-B-25 px-30 pb-60 pt-30"
      aria-labelledby="how-to-collect-heading"
    >
      <motion.div
        ref={ref}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        variants={containerVariants}
        className="flex w-full flex-col items-center gap-48 rounded-large bg-[rgba(255,255,255,0.3)] py-40"
        style={{
          boxShadow: '0px 0px 10px 0px rgba(148,213,248,0.3)',
        }}
      >
        <div className="flex flex-col items-center gap-14">
          <motion.h2
            id="how-to-collect-heading"
            variants={itemVariants}
            className="text-center text-Gray-900"
          >
            <Image
              src={TYPOGRAPHY_IMAGES.howToCollectHeading.url}
              alt={TYPOGRAPHY_IMAGES.howToCollectHeading.alt}
              width={TYPOGRAPHY_IMAGES.howToCollectHeading.width}
              height={TYPOGRAPHY_IMAGES.howToCollectHeading.height}
              loading="lazy"
              className="mx-auto object-contain"
            />
          </motion.h2>
          <motion.p
            variants={itemVariants}
            className="text-center font-400 text-Gray-700 typo-body4"
          >
            스탬프는 10개 지역 기준으로 지급돼요.
            <br />
            같은 지역에 여러 번 기부해도 스탬프는 1개만!
            <br />
            중복 기부 시, 처음 받은 스탬프가 표시돼요.
          </motion.p>
        </div>

        <motion.div
          variants={itemVariants}
          className="flex w-full flex-col items-center gap-14 px-40"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={
              isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }
            }
            transition={{ duration: 0.4, delay: 0.4 }}
            className="flex w-full flex-col gap-14"
          >
            <RegionListContent />
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};
